import type React from 'react';
import type { ReactNode } from 'react';

interface MediaCardActionMenuContainerProps {
  children?: ReactNode;
}

export const MediaCardActionMenuContainer: React.FC<MediaCardActionMenuContainerProps> = ({ children }) => {
  return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>{children}</div>;
};
